var map = {
	"./abhi.jpg": "./src/Components/pics/abhi.jpg",
	"./ajit.jpg": "./src/Components/pics/ajit.jpg",
	"./aman.jpg": "./src/Components/pics/aman.jpg",
	"./avani.jpg": "./src/Components/pics/avani.jpg",
	"./bhupesh.jpg": "./src/Components/pics/bhupesh.jpg",
	"./deep.jpg": "./src/Components/pics/deep.jpg",
	"./gp.jpg": "./src/Components/pics/gp.jpg",
	"./jn.jpg": "./src/Components/pics/jn.jpg",
	"./paras.jpg": "./src/Components/pics/paras.jpg",
	"./siri.jpg": "./src/Components/pics/siri.jpg",
	"./spm.jpg": "./src/Components/pics/spm.jpg",
	"./srilaxmi.jpg": "./src/Components/pics/srilaxmi.jpg",
	"./tanvi.jpg": "./src/Components/pics/tanvi.jpg",
	"./vanshika.jpg": "./src/Components/pics/vanshika.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Components/pics sync recursive ^\\.\\/.*\\.jpg$";